/**
 * [ File :: G_ImageInspector.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/child/image/G_ImageInspector.js
 * @설명 : 정답지와 객체를 비교하는 조사자 객체
 * @진행 : 종료
 * @주의 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Define from 'canvas/base/dev/util/B_Define';
import G_ImageGrid from 'canvas/grid/dev/child/image/G_ImageGrid';

const G_ImageInspector = (function() {

	return class extends G_ImageGrid {

		constructor(obj) { super(obj); }

		// @DES :: _objTarget {obj} - 타겟 객체
		get _objTarget () {
			return Array.isArray(this._target)
				? this._target.map(e => this.CODMOS.WORLD.LIST.solution[e])
				: this.CODMOS.WORLD.LIST.solution[this._target]
		}

		/**
		 * [ Function (protected) :: _checkSolution ]
		 *
		 * @DES :: 목표지점 로직체크
		 * @IP1 :: hero {obj}
		 * @IP2 :: cb {func}
		 */
		_checkSolution (hero, cb) {
			
			/**
			 * [STEP]
			 *
			 * #01. 타켓 유무
			 * #02. 출입 제한
			 * #03. 우선 순위
			 * #04. 정답지
			 */
			
			const STATE = this.CODMOS.WORLD.STATE;
			let targetObj = this._objTarget

			// [CASE1] 타겟 유무 확인 (타겟 없다면 패스)
			if (targetObj) {
				// [#] 임시성공처리 => 실패가 있다면 clear 정보가 'false' 로 바뀌어 있을것!
				STATE.going(B_Define.CLEAR_STATUS['GOING'], "TEMP");

				if (!Array.isArray(targetObj)) targetObj = [targetObj]
				for (let i = 0; i < targetObj.length; i++) {
					const SOLUTION = targetObj[i]

					// # 1. 출입제한 처리
					if (SOLUTION.limit) SOLUTION._compareLimit(hero._id);

					// # 2. 우선순위처리
					if (STATE.play && SOLUTION.order) SOLUTION._compareOrder();

					// # 3. 정답지 처리
					if (STATE.play && SOLUTION.answerSheet) {

						// # 3.1. 인벤토리 정답지 처리
						if (STATE.play && SOLUTION.answerSheet.inventory) {
							SOLUTION._compareInventory(hero);
						}

						// # 3.2. 변수 정답지 처리
						if (STATE.play && SOLUTION.answerSheet.variable) SOLUTION._compareVariable();

						// # 3.2. 오브젝트 value 정답지 처리
						if (STATE.play && SOLUTION.answerSheet.value) SOLUTION._compareValue();
					}

					if (STATE.clear !== B_Define.CLEAR_STATUS['GOING']) break

				}
				cb();
			}
			// [CASE2] 타겟 없다면 성공으로 간주
			else {
				STATE.going(B_Define.CLEAR_STATUS['SUCCESS'], B_Define.REASON['SUCCESS'], this);
				cb();
			}

		}

	}
}());

export default G_ImageInspector;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/image/G_ImageInspector.js